import bgImage from "../assets/images/Party.png";

export const T = {
  font: '"Airbnb Cereal", sans-serif',
  text: "#FFFFFF",
  sub: "#B8B0C8",
  muted: "#8E889E",
  border: "#FFFFFF1C",
  card: "rgba(58, 24, 88, 0.72)",
  cardSolid: "rgba(52, 20, 80, 0.85)",
  radius: 20,
  radiusSm: 14,
  shadow: "0 10px 28px rgba(0,0,0,0.35)",
  green: "#00FF26",
  greenToggle: "#2ED573",
  rose: "#FF3B5C",
  amber: "#FF9F1A",
  purple: "#9B2CFF",
  pink: "#FF2D8F",
  gradPinkPurple: "linear-gradient(90deg, #FF2D8F 0%, #9B2CFF 100%)",
  gradProfile: "linear-gradient(90deg, #FF2D8F 0%, #B02BFF 45%, #6B1AFF 100%)",
  iconBox: "#FFFFFF12",
  navInactive: "rgba(200,190,220,0.55)",
  tabInactive: "rgba(255,255,255,0.08)",
};

export const pageBgStyle = {
  backgroundImage: `url(${bgImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center top",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  minHeight: "100vh",
  color: T.text,
  fontFamily: T.font,
};

export const glassCard = {
  background: "#FFFFFF14",
  border: "1px solid #FFFFFF1C",
  borderRadius: "16px",
  backdropFilter: "blur(16px)",
  WebkitBackdropFilter: "blur(16px)",
  boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
};

/* Header scrolls away with page (not sticky) */
export const pageHeader = {
  position: "relative",
  zIndex: 9,
  background: "transparent",
  padding: "16px 16px 10px",
  borderBottom: "none",
};

export const headerTitle = {
  fontFamily: T.font,
  fontWeight: 700,
  fontSize: 20,
  color: "#FFFFFF",
  lineHeight: 1,
};

export const headerDesc = {
  fontFamily: T.font,
  fontWeight: 400,
  fontSize: 14,
  color: "#FFFFFF80",
  marginTop: 4,
  lineHeight: 1.35,
};

/* keep alias so older imports don't break */
export const stickyHeader = pageHeader;

export { bgImage };
